import { render, staticRenderFns } from "./ProductsList.vue?vue&type=template&id=252d11da&scoped=true"
import script from "./ProductsList.js?vue&type=script&lang=js&external"
export * from "./ProductsList.js?vue&type=script&lang=js&external"
import style0 from "./ProductsList.scss?vue&type=style&index=0&id=252d11da&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "252d11da",
  null
  
)

export default component.exports